import React from 'react';
import LoadingIndicator, { LoadingIndicatorProps } from '../loader';

export interface CustomLoadingProps extends LoadingIndicatorProps {}

const CustomLoading: React.FC<CustomLoadingProps> = (props) => {
  return <LoadingIndicator {...props} />;
};

export default CustomLoading;
